/** Normaliza `recurso` o `recurso:ACCION` del login/JWT. */
export function normalizePermiso(raw: string): string {
  return raw.trim().toLowerCase();
}

export function collectPermisos(...groups: Array<string[] | null | undefined>): string[] {
  const out: string[] = [];
  for (const group of groups) {
    if (!group?.length) continue;
    for (const item of group) {
      if (typeof item === 'string' && item.trim()) out.push(item);
    }
  }
  return out;
}

export function permisosFromJwt(token: string | null | undefined): string[] {
  const payload = decodeJwtPayload(token);
  const raw = payload?.['permisos'];
  if (!Array.isArray(raw)) return [];
  return raw.filter((item): item is string => typeof item === 'string');
}

export function decodeJwtPayload(token: string | null | undefined): Record<string, unknown> | null {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const padded = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(padded);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function isSuperAdminRole(role: string | null | undefined, roles?: string[] | null): boolean {
  const names = [role, ...(roles ?? [])].filter(Boolean) as string[];
  return names.some((name) => /superadmin/i.test(name));
}

/**
 * `recurso:ACCION` gana. El token también manda el recurso suelto (`solicitudes`);
 * eso cuenta como `ver`.
 */
export function hasPermission(
  permisos: string[] | null | undefined,
  recurso: string,
  accion = 'ver',
  options?: { superAdmin?: boolean }
): boolean {
  if (options?.superAdmin) return true;
  if (!recurso.trim()) return false;

  const rec = normalizePermiso(recurso);
  const act = normalizePermiso(accion);
  const set = new Set((permisos ?? []).map(normalizePermiso));

  if (set.has(`${rec}:${act}`)) return true;
  if (act === 'ver' && set.has(rec)) return true;
  return false;
}
